let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eA4Ts")).then(() => parcelRequire('fYqHn'));